export const ANALYTICS_EVENT_NAMES = {
    HOME_VIEWED: "homepage_viewed",
    SECTION_SWITCHED: "section_switched",
    CONTACT_US_CLICKED: "contact_us_clicked",
    SEARCH_INITIATED: "search_initiated",
    SEARCH_EXECUTED: "search_executed",
    CART_VIEWED: "cart_viewed",
    BAG_SUMMARY_VIEWED: "bag_summary_viewed",
    PROFILE_MENU_OPENED: "profile_menu_opened",
    QUANTITY_UPDATED: "quantity_updated",
    ORDER_DETAILS_VIEWED: "order_details_viewed",
    PRODUCT_REMOVED: "product_removed",
    NAV_DROPDOWN_ITEM_CLICKED: "nav_dropdown_item_clicked",
    STORY_IMAGE_CLICKED: "story_image_clicked",
    STORY_CTA_CLICKED: "story_cta_clicked",
    SHOP_NOW_CLICKED: "shop_now_clicked",
    CATEGORY_CLICKED: "category_clicked",
    EDIT_STORY_IMAGE_CLICKED: "edit_story_image_clicked",
    EDIT_STORY_CTA_CLICKED: "edit_story_cta_clicked",
    INSTAGRAM_POST_CLICKED: "instagram_post_clicked",
    OPEN_INSTAGRAM_CTA_CLICKED: "open_instagram_cta_clicked",
    NEWSLETTER_SUBSCRIBED: "newsletter_subscrition",
    FOOTER_LINK_CLICKED: "footer_link_clicked",
    PLP_VIEWED: "plp_viewed",
    FILTER_APPLIED: "filter_applied",
    SORT_APPLIED: "sort_applied",
    PAGINATION_CLICKED: "pagination_clicked",
    PRODUCT_CLICKED: "product_clicked",
    STORY_DETAIL_VIEWED: "story_detail_viewed",
    STORY_PRODUCT_CLICKED: "story_product_clicked",
    PDP_VIEWED: "pdp_viewed",
    ADD_TO_FAVOURITE: "add_to_favourite",
    SIZE_GUIDE_VIEWED: "size_guide_clicked",
    ADD_TO_BAG: "add_to_bag",
    RETURN_POLICY_CLICKED: "return_policy_clicked",
    PROCEED_TO_CHECKOUT: "proceed_to_checkout",
    PROCEED_TO_CHECKOUT_CLICKED: "proceed_to_checkout_clicked",
    CHECKOUT_USER_DECISION: "checkout_user_decision",
    GUEST_ADDRESS_ADDED: "guest_address_added",
    ADDRESS_SELECTED: "address_selection",
    ADDRESS_SAVED: "address_saved",
    NEW_ADDRESS_ADDED: "new_address_added",
    REVIEW_SHIPPING_BILLING_ADDRESS: "review_shipping_billing_address",
    PROMOTION_APPLIED: "promotion_applied",
    PROMOTION_FAILED: "promotion_failed",
    PAYMENT_INITIATED: "payment_initiated",
    PAYMENT_COMPLETED: "payment_completed",
    PAYMENT_FAILED: "payment_failed",
    ORDER_PLACED: "order_placed",
    USER_ICON_CLICKED: "user_icon_clicked",
    USER_OPTION_SELECTED: "user_option_selected",
    MY_ACCOUNT_PAGE_VIEWED: "my_account_page_viewed",
    PROFILE_UPDATED: "profile_updated",
    FAVORITES_PAGE_VIEWED: "favorites_page_viewed",
    FAVORITE_PRODUCT_CLICKED: "favorite_product_clicked",
    ORDER_HISTORY_PAGE_VIEWED: "order_history_viewed",
    SAVED_CARDS_PAGE_VIEWED: "saved_cards_viewed",
    SAVED_CARD_DELETED: "saved_card_deleted",
    SAVED_ADDRESSES_PAGE_VIEWED: "saved_addresses_viewed",
    USER_SIGNED_OUT: "user_signed_out",
    PRODUCT_ABONDONED: "product_abandoned",
    NEW_CARD_ADDED: "new_card_added",
    VIDEO_PLAYED: "video_play",
    VIDEO_PRODUCT_CLICKED: "video_product_clicked",
};
